import { createContext, useContext, useEffect } from 'react';

// Lets an admin page put its own controls (e.g. the dashboard filter bar) in
// the fixed header, in place of the default search. DashboardLayout provides
// { node, claim }: the header DOM node to portal into, and claim(), which
// hides the default search until the returned release function runs.
export const HeaderSlotContext = createContext(null);

// Returns the header node to portal into while `enabled`, otherwise null.
export function useHeaderSlot(enabled) {
  const slot = useContext(HeaderSlotContext);
  const active = Boolean(slot) && enabled;

  useEffect(() => (active ? slot.claim() : undefined), [active, slot]);

  return active ? slot.node : null;
}
